import { network } from 'services/network';
import { useMutation } from 'react-query';

const mutationFn = (params: QueryParams) => {
    return network.post('api/bo/getUserExtDomain', { username: params.username }).then((response) => {
        return response.data;
    });
};
export const useMutationGetUserDomain = () => {
    return useMutation<QueryResponse, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

interface QueryParams {
    username: string;
}

interface QueryResponse {
    domain: string;
}
